export default (function () {
    const footer = {
        initToggle() {
            $('.js--footer__switcher').click(function () {
                if (window.innerWidth < 768) {
                    $(this).toggleClass('active');
                    $(this).closest('.js--collapse').find('.js--footer__toggle').slideToggle();
                }
            });
        },
    };
    $(document).ready(() => {
        footer.initToggle();
    });
}());
